import Button from 'apollo-react/components/Button';
import styles from './Button.module.css';

const ButtonCustom = (props) => {
  // icon must be from apollo-react-icons
  const { text, color, onClick, icon, status, style, className } = props;
  return (
    <Button
      {...props}
      size="small"
      onClick={onClick}
      variant={color}
      icon={icon}
      status={status}
      className={`${styles.button} ${className || ''}`}
      style={style}
    >
      {text}
    </Button>
  );
};

export default ButtonCustom;
